import { VueEditor } from 'vue2-editor'

let editorToolbar = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{ 'header': 1 }, { 'header': 2 }],
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  [{ 'script': 'sub' }, { 'script': 'super' }],
  [{ 'indent': '-1' }, { 'indent': '+1' }],
  [{ 'size': ['small', false, 'large', 'huge'] }],
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  [{ 'color': [] }, { 'background': [] }],
  [{ 'align': [] }],
  ['link', 'image', 'video'],
  ['showHtml']
]

function showHTMLButton (editor, container) {
  // Pega quill
  let quill = editor.quill
  // Cria TextArea HTML
  let txtArea = document.createElement('textarea')
  txtArea.style.cssText = 'width: 100%;margin: 0px;background: rgb(29, 29, 29);box-sizing: border-box;color: rgb(204, 204, 204);font-size: 15px;outline: none;padding: 20px;line-height: 24px;font-family: Consolas, Menlo, Monaco, &quot;Courier New&quot;, monospace;position: absolute;top: 0;bottom: 0;border: none;display:none'
  txtArea.addEventListener('keyup', function () {
    quill.pasteHTML(txtArea.value)
  })
  // Cria Text Area
  let htmlEditor = quill.addContainer('ql-custom')
  htmlEditor.appendChild(txtArea)
  let customButton = document.querySelector('.ql-showHtml')
  customButton.addEventListener('click', function () {
    txtArea.value = editor.value
    txtArea.style.display = txtArea.style.display === 'none' ? '' : 'none'
  })
}

export { VueEditor, editorToolbar, showHTMLButton }
